'use client'

import Image from 'next/image'

export default function BannerDownloadApp() {
  return (
    <section className="container mx-auto">
      <div className='bg-bright-pink rounded-xl p-6 md:p-12 text-white flex flex-col md:flex-row items-center justify-between gap-8'>
        {/* Imagen de la app */}
      <div className="flex-1 relative w-full max-w-md min-h-[420px] overflow-hidden rounded-xl">
        <Image
          src="https://maluapp.b-cdn.net/resources/appbanner.png"
          alt="App Malú Pérez"
          height={420}
          width={896}
          className="object-cover object-bottom absolute bottom-0 left-0 w-full h-full"
          priority
        />
      </div>

      {/* Texto y botones */}
      <div className="flex-1 text-center md:text-left">
        <h2 className="text-2xl md:text-4xl font-bold mb-4">¡LLEVA TU ENTRENAMIENTO CONTIGO!</h2>
        <p className="mb-4 text-white text-base font-light md:text-lg">
          Con nuestra app accedes a más de +500 clases desde donde estés, cuando quieras. Entrena con Malú y lleva tu progreso al siguiente nivel.
        </p>
        <ul className="text-white text-left  ml-4 mb-6 space-y-1 font-light">
          <li>🧘 Pilates, Dance Fit, Barralates y más</li>
          <li>🗓️ Planificador de entrenamientos</li>
          <li>🥗 Nutrición personalizada</li>
          <li>📈 Seguimiento de tu evolución</li>
        </ul>
        <p className="font-semibold mb-4">¡COMIENZA A ENTRENAR DESDE LA APP!</p>

        {/* Botones */}
        <div className="flex justify-center md:justify-start gap-4">
          <a href="https://play.google.com/store/apps/details?id=com.maluperezonlineapp.maluperezapp" target="_blank" rel="noopener noreferrer">
            <Image
              src="https://maluapp.b-cdn.net/resources/play-store-download.png"
              alt="Google Play"
              width={170}
              height={45}
            />
          </a>
          <a href="https://apps.apple.com/cl/app/mal%C3%BA-p%C3%A9rez-app/id6744512179" target="_blank" rel="noopener noreferrer">
            <Image
              src="https://maluapp.b-cdn.net/resources/app-store-download.png"
              alt="App Store"
              width={170}
              height={45}
            />
          </a>
        </div>
      </div>
      </div>
    </section>
  )
}
